<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          ref="purchaseForm"
          :model="purchase"
          class="box"
          label-width="80px"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$t('purchase.serialNo')">
                  <span v-if="purchase.hurry" class="red">
                    ({{ $t("order.hurrySimple") }})
                  </span>
                  {{ purchase.serialNo }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.workflowState')">
                  {{ $t("purchaseStates." + purchase.workflowState) }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('menu.suppliers')">
                  {{ purchase.supplierName }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.owner')">
                  {{ purchase.ownerName }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">
                  {{ purchase.createAt }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.handOverAt')">
                  {{ purchase.handOverAt }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="7">
                <el-form-item :label="$t('purchase.giveAt')">
                  {{ purchase.giveAt }}
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  :label="$t('purchase.finishAt')"
                  label-width="100px"
                >
                  {{ purchase.finishAt }}
                </el-form-item>
              </el-col>

              <el-col :span="10">
                <el-form-item
                  :label="$t('purchase.supplierDeliveryAt')"
                  label-width="140px"
                >
                  {{ purchase.supplierDeliveryAt }}
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('purchase.settlement')">
                  <span v-if="purchase.settlementId == null">
                    {{ $t("boolean.false") }}
                  </span>
                  <span v-if="purchase.settlementId != null">
                    {{ $t("boolean.true") }}
                  </span>
                </el-form-item>
              </el-col>
              <el-col v-if="purchase.manualSettleAt != null" :span="6">
                <el-form-item :label="$t('purchase.manualSettleAt')">
                  {{ purchase.manualSettleAt }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>
              {{ $t("order.productInfo") }}
              <a
                v-if="purchase.attachment"
                class="fr blue"
                target="_blank"
                :href="purchase.attachment"
              >
                {{ $t("action.downloadAttatchment") }}
              </a>
            </legend>

            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$t('product.productNo')">
                  {{ purchase.productNo }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.category')">
                  {{ purchase.categoryName }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.brand')">
                  {{ purchase.productBrand }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item :label="$t('product.color')">
                  <span class="float-left mgr5">{{ purchase.color }}</span>
                  <thumbnail
                    class="mgt5"
                    v-if="purchase.colorImage != null"
                    :images="purchase.colorImage"
                    width="25"
                    height="25"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.size')">
                  {{ purchase.size }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.quantity')">
                  {{ purchase.quantity }} {{ purchase.unit }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col v-if="Permit.canActions('globalPurchasePrice')" :span="8">
                <el-form-item :label="$t('purchase.price')">
                  {{ purchase.price }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset
            v-if="
              purchase.specJson != null &&
              purchase.specJson != '' &&
              JSON.parse(purchase.specJson).length != 0
            "
            class="mgb15"
          >
            <legend>{{ $t("product.specJson") }}</legend>
            <el-tag
              v-for="s in JSON.parse(purchase.specJson)"
              :key="s.name"
              type="info"
              >{{ s.name }}：{{ s.value }}</el-tag
            >
          </fieldset>
          <fieldset v-if="purchase.images != null" class="mgb15">
            <legend>{{ $t("product.images") }}</legend>
            <thumbnail :images="purchase.images" list></thumbnail>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("product.craftwork") }}</legend>
            <raw-html :content="purchase.craftwork" type="richText" />
          </fieldset>
          <fieldset
            v-if="purchase.remark != null && purchase.remark != ''"
            class="mgb15"
          >
            <legend>{{ $t("text.remark") }}</legend>
            <raw-html :content="purchase.remark" type="richText" />
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("purchase.receiveAdress") }}</legend>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('user.name')">
                  {{ purchase.customerName }}
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('user.phone')">
                  {{ purchase.customerPhone }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('tenant.address')">
                  <span v-if="purchase.country != null">
                    {{ $t("countries." + purchase.customerCountry) }}
                  </span>
                  {{ purchase.customerProvince || "" }}
                  {{ purchase.customerCity || "" }}
                  {{ purchase.customerAddress || "" }}
                  <span v-if="purchase.customerZipcode != null" class="font10">
                    ({{ purchase.customerZipcode || "" }})
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset v-if="purchase.untreadAt != null" class="mgb15">
            <legend>{{ $t("purchase.untrodInfo") }}</legend>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('purchase.untreadAt')">
                  {{ purchase.untreadAt }}
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item :label="$t('purchase.untreadReason')">
                  {{ purchase.untreadReason }}
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Purchase from "@/api/purchase.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
  },
  data() {
    return {
      purchase: { workflowState: "newly" },
    };
  },
  created() {
    const self = this;
    self.getPurchase();
  },
  methods: {
    getPurchase() {
      const self = this;
      self.loadingStart();
      Purchase.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.purchase = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>